export default __webpack_public_path__ + "media/color/mona-9823b12c.svg";